import { ISettings } from '@modules/settings';
import { IDetailedUser } from '@modules/users';

export const addressMaker = (warehouseDetails: ISettings['foreignWarehouses'][0], user: IDetailedUser) => {
  const { address } = warehouseDetails;
  return address.replace(/{{client.id}}/g, user.id.toString()).replace(/{{client.name}}/g, user.fullName);
};
